import { rSetAlert } from "../../../reducers/session/actions";
import { capitalizeFirstLetter } from "../../../utils/string";
import { User } from "../../../models/users";
import logging from "../../../utils/logging";
import { PwgError } from "../../../models/common";
import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "../../../firebase/firebaseClient";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
const fileDownload = require("js-file-download");

export const generatePdf = async (user_id: string) => {
  const functions = getFunctions(firebaseApp);
  const storage = getStorage(firebaseApp);
  const onGeneratePdf = httpsCallable(functions, "onGeneratePrepFqPdf");
  await onGeneratePdf();
  const storageRef = ref(
    storage,
    `users/${user_id}/prep_fq_profile/Prep-Fq-Report.pdf`
  );
  const dlUrl = await getDownloadURL(storageRef);
  return dlUrl;
};

export const getDownloadUrl = async (user_id: string) => {
  const storage = getStorage(firebaseApp);
  const storageRef = ref(
    storage,
    `users/${user_id}/prep_fq_profile/Prep-Fq-Report.pdf`
  );
  const dlUrl = await getDownloadURL(storageRef);
  return dlUrl;
};

export const downloadPdf = async (
  dispatch: any,
  t: any,
  user: User,
  downloadUrl: string,
  user_id: string,
  pathname: string
) => {
  dispatch(
    rSetAlert({
      key: new Date().getTime().toString(),
      message: t("common:loading.prepFqReport"),
      type: "info",
      icon: "download",
      duration: 36000,
    })
  );
  try {
    const xhr = new XMLHttpRequest();
    xhr.responseType = "blob";
    xhr.onload = async () => {
      const blob = xhr.response;
      await fileDownload(
        blob,
        `Preparedness Report - ${capitalizeFirstLetter(
          user.first_name
        )} ${capitalizeFirstLetter(user.last_name)}.pdf`
      );
      dispatch(
        rSetAlert({
          key: new Date().getTime().toString(),
          message: t("common:success.prepFqReport"),
          type: "success",
        })
      );
    };
    xhr.onerror = (error) => {
      const pwgError: PwgError = {
        user_id,
        ssr: false,
        context: "downloadPdf: onerror",
        date_created: new Date().getTime(),
        error: error?.toString(),
        pathname,
      };
      logging.e(
        "🚀 ~ file: generatePdf.tsx ~ line 67 ~ downloadPdf ~ error",
        error,
        pwgError
      );
      dispatch(
        rSetAlert({
          key: new Date().getTime().toString(),
          message: t("common:errors.generic"),
          type: "error",
        })
      );
    };
    xhr.open("GET", downloadUrl);
    xhr.send();
  } catch (error) {
    const pwgError: PwgError = {
      user_id,
      ssr: false,
      context: "downloadPdf: onerror",
      date_created: new Date().getTime(),
      error: error?.toString(),
      pathname,
    };
    await logging.e(
      "🚀 ~ file: generatePdf.tsx ~ line 67 ~ downloadPdf ~ error",
      error,
      pwgError
    );
    dispatch(
      rSetAlert({
        key: new Date().getTime().toString(),
        message: t("common:errors.generic"),
        type: "error",
      })
    );
  }
};
